import React, { Component, PropTypes } from 'react';
import { ThemeStore } from 'stores';
import { Units, Colors } from 'Css';
import classNames from 'classnames';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import StoreBar from 'components/StoreBar';
import EmbeddedVideoPreview from 'components/EmbeddedVideoPreview';
import ProfileImage from 'components/Widgets/ProfileImage';
import { FlatButton } from 'material-ui';
import * as SvgIcons from 'components/Material/SvgIcons';
import StoreTabs from 'components/Store/StoreTabs';
import CourseTableOfContentsContainer from 'components/Store/CourseTableOfContentsContainer';
import CoursePackageList from 'components/Store/CoursePackageList';
import LinkList from 'components/Widgets/LinkList';
import StoreItemEditPanel from 'components/Store/StoreItemEditPanel';
import { Media } from 'Util';
import GiftDialog from 'containers/Store/GiftDialog';
import { StoreOverviewActions } from 'actions';
import Helmet from 'react-helmet';
import TaC from '../TaC/StoreTaC';
import Gift from 'Cio/Assets/Gift';

const css = oxygenCss({
  padded: {
    padding: Units.base
  },
  root: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: Colors.theme.Light.card
  },
  header: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    height: Units.keyline
  },
  body: {
    position: 'absolute',
    top: Units.keyline,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'auto',
    '@phone': {
      bottom: Units.keyline * 1.5
    }
  },
  backButton: {
    cursor: 'pointer',
    position: 'absolute',
    height: 32,
    minWidth: 72,
    top: -16,
    left: 24,
    lineHeight: '32px',
    padding: `0 ${Units.base * 2}px`,
    borderRadius: 16,
    backgroundColor: Colors.theme.Light.card,
    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)',
    display: 'none',
    '@desktop': {
      display: 'block'
    },
    '>SVG': {
      verticalAlign: 'middle',
      marginRight: Units.base
    }
  },
  main: {
    right: 'auto',
    bottom: 'auto',
    overflow: 'initial',
    position: 'relative',
    '@desktop': {
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      right: Units.keyline * 8
    },
    ' IMG': {
      margin: 'auto',
      display: 'block',
      maxWidth: '100%'
    }
  },
  buyButton: {
    transition: 'all 0.25s ease',
    fontFamily: 'MaisonNeue-Demi',
    cursor: 'pointer',
    borderRadius: 3,
    backgroundColor: '#f04f4f',
    minWidth: 64,
    textAlign: 'center',
    padding: `0px 4px`,
    color: Colors.fullWhite,
    fontSize: 16,
    height: 40,
    lineHeight: '40px',
    letterSpacing: '0.6px',
    boxSizing: 'border-box',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    ':hover': {
      boxShadow: '0 2px 0 0 #d64646',
      backgroundColor: '#ff5555'
    }
  },
  callToAction: {
    flexGrow: 0,
    // borderStyle: 'solid none none none',
    borderWidth: 1,
    borderColor: '#f0f0f0',
    display: 'flex',
    '@phone': {
      flexGrow: 1
    }
  },
  buttonWrapper: {
    margin: Units.base,
    flexGrow: 1
  },
  giftButtonWrapper: {
    margin: Units.base,
    flexGrow: 0
  },
  giftButton: {
    transition: 'all 0.25s ease',
    fontFamily: 'MaisonNeue-Demi',
    fontSize: 14,
    lineHeight: '18px',
    letterSpacing: '0.1px',
    cursor: 'pointer',
    minWidth: 64,
    textAlign: 'center',
    padding: `10px 4px`,
    color: '#646464',
    ':hover': {
      backgroundColor: 'rgba(255, 80, 80, 0.1)',
      borderRadius: 100,
      color: '#ff5555'
    }
  },
  giftIcon: {
    // margin: `0 ${Units.base}px`
  },
  videoContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  noVideo: {
    ' main': {
      '@desktop': {
        left: '50%',
        right: 'auto',
        marginLeft: `${Units.keyline * -7.5}px`,
        width: Units.keyline * 15,
        boxShadow:
          '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)'
      },
      width: 'auto',
      left: 0,
      right: 0,
      boxShadow: 'none',
      marginLeft: 0
    },
    ' content': {
      '@desktop': {
        left: '50%',
        right: 'auto',
        marginLeft: `${Units.keyline * -7.5}px`,
        width: Units.keyline * 15
      },
      left: 0,
      right: 0,
      marginLeft: 0,
      width: 'auto'
    }
  },
  sidebar: {
    position: 'relative',
    right: 'auto',
    top: 'auto',
    bottom: 'auto',
    width: 'auto',
    overflow: 'auto',
    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)',
    zIndex: 1,
    ' IMG': {
      margin: 'auto',
      display: 'block',
      maxWidth: '100%'
    },
    '@desktop': {
      position: 'absolute',
      right: 0,
      top: 0,
      bottom: 112,
      width: Units.keyline * 8
    }
  },
  courseTitle: {
    fontWeight: 'bold',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'pre-line'
  },
  coursePrice: {
    fontWeight: 'bold'
  },
  courseAccess: {
    fontWeight: '100',
    color: '#777',
    display: 'none',
    '@desktop': {
      display: 'block'
    }
  },
  courseAccess1: {
    fontWeight: '100',
    color: '#777',
    display: 'none',
    '@phone': {
      display: 'block'
    }
  },
  content: {
    overflow: 'visible',
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto',
    position: 'relative',
    width: '100%',
    zIndex: 1,
    ' IMG': {
      margin: 'auto',
      display: 'block',
      maxWidth: '100%'
    },
    '@desktop': {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: Units.keyline * 1.75,
      overflow: 'auto',
      width: 'auto'
    }
  },
  footer: {
    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    // height: 112,
    display: 'flex',
    padding: Units.base,
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 100,
    backgroundColor: Colors.theme.Light.card,
    animation: 'repaint 5000ms',
    '@phone': {
      alignItems: 'stretch',
      position: 'absolute',
      fontWeight: 'bold',
      padding: 0,
      fontSize: 14,
      // height: Units.keyline * 1.5,
      lineHeight: `24px`
    }
    // boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)',
  },
  itemInfo: {},
  courseInfo: {
    flexGrow: 1,
    flexShrink: 0,
    boxSizing: 'border-box',
    padding: Units.base,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    width: '66%',
    display: 'none',
    '@desktop': {
      width: 'auto',
      display: 'block'
    },
    '&spacing': {
      padding: Units.base / 2,
      '@desktop': {
        padding: `${Units.base}px ${Units.base}px ${
          Units.base
        }px ${Units.keyline * 2}px`
      }
    }
  },
  courseInfo1: {
    flexGrow: 1,
    flexShrink: 0,
    boxSizing: 'border-box',
    padding: Units.base * 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    width: '66%',
    display: 'none',
    '@phone': {
      display: 'block'
    },
    '&spacing': {
      padding: Units.base,
      '@desktop': {
        padding: `${Units.base * 2}px`
      }
    }
  },
  packageInfo: {
    padding: Units.base,
    display: 'none',
    '@desktop': {
      display: 'block'
    }
  },
  ownerInfo: {
    flex: '1 0 auto',
    padding: '3px 8px 3px 72px',
    position: 'relative',
    display: 'none',
    '@desktop': {
      display: 'block'
    }
  },
  ownerInfo1: {
    flex: '1 0 auto',
    padding: `${Units.base}px ${Units.base}px ${Units.base}px ${Units.base}px`,
    position: 'relative',
    display: 'none',
    '@phone': {
      display: 'block'
    }
  },
  profileImage: {
    position: 'absolute',
    left: Units.base,
    top: 0,
    bottom: 0,
    width: 48
  },
  profileImage1: {
    '@phone': {
      display: 'none'
    }
  },
  packBadge: {
    minWidth: 64,
    textAlign: 'center',
    lineHeight: '24px',
    padding: `${Units.base / 2}px ${Units.base}px`,
    color: Colors.fullWhite,
    fontWeight: 500,
    backgroundColor: '#FF5555',
    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)',
    '>SVG': {
      verticalAlign: 'middle',
      marginRight: Units.base
    }
  },
  panel: {
    padding: Units.base,
    '@desktop': {
      padding: Units.base * 4
    }
  },
  '@repaint': {
    from: {
      width: '99.9999%'
    },
    to: {
      width: '100%'
    }
  }
});

const lookup = {
  0: 'Unlimited',
  1: 'oneMonth',
  3: 'threeMonths',
  6: 'sixMonths',
  12: 'oneYear',
  24: 'twoYears'
};

class StoreItem extends Component {
  static propTypes = {
    item: PropTypes.object,
    store: PropTypes.string,
    canIEdit: PropTypes.bool,
    themeColor: PropTypes.string,
    logoUrl: PropTypes.string,
    owner: PropTypes.object,
    history: PropTypes.object,
    purchase: PropTypes.bool,
    loggedIn: PropTypes.bool
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  state = {
    mode: 'detail',
    tab: 'course',
    tac: false
  };

  componentDidMount() {
    const { purchase, item } = this.props;
    if (purchase) {
      StoreOverviewActions.addToCart(item);
    }
  }

  parseVideoUrl(videoUrl) {
    try {
      const provider = JSON.parse(videoUrl);
      provider.id = provider.src;
      const parsedUrl = Media.getUrlFromProvider(provider);
      return parsedUrl;
    } catch (e) {
      try {
        const parsedUrl = Media.getEmbedUrl(videoUrl);
        return parsedUrl;
      } catch (e1) {
        return videoUrl;
      }
    }
    return videoUrl;
  }

  strip(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  renderSideBar(item) {
    const { getIntlMessage } = this.context;
    const { themeColor, canIEdit, store, owner } = this.props;
    const { tab } = this.state;
    const { type, id, presentation, price } = item;
    const videoUrl = this.parseVideoUrl(item.videoUrl);
    const tabs = [
      {
        name: 'course',
        label: getIntlMessage('store.aboutThisCourse')
      }
    ];
    if (type === 1) {
      tabs.push({
        name: 'content',
        label: getIntlMessage('store.courseContent')
      });
    } else {
      tabs.push({
        name: 'content',
        label: (
          <FormattedMessage
            message={getIntlMessage('store.courseCount')}
            count={item.courses.length}
          />
        )
      });
    }
    if (canIEdit) {
      tabs.push({
        name: 'edit',
        label: getIntlMessage('Edit')
      });
    }

    const links = [
      { href: '/tac', text: getIntlMessage('TermsAndConditions') }
    ];

    const ucpPeriod = parseInt(item.ucpPeriod, 10);
    const displayVideo = videoUrl || (!videoUrl && canIEdit);

    const accessMonths = Math.floor(ucpPeriod / (24 * 60 * 60 * 30));
    const accessDescription = lookup[accessMonths] ? (
      getIntlMessage('invite.' + lookup[accessMonths])
    ) : (
      <FormattedMessage
        message={getIntlMessage('invite.accessMonths')}
        months={accessMonths}
      />
    );

    return (
      <div
        className={classNames({
          [css.sidebar]: displayVideo,
          [css.content]: !displayVideo
        })}
      >
        <StoreTabs
          onChange={nextTab => this.setState({ tab: nextTab })}
          themeColor={ThemeStore.getColor(themeColor)}
          activeTab={tab}
          tabs={tabs}
        />
        {tab === 'content' &&
          type === 2 && (
            <div className={css.panel}>
              <CoursePackageList
                themeColor={themeColor}
                courses={item.courses}
              />
            </div>
          )}
        {tab === 'content' &&
          type === 1 && (
            <div className={css.panel}>
              <CourseTableOfContentsContainer courseId={id} />
            </div>
          )}
        {tab === 'course' && (
          <div>
            <div
              className={classNames(css.courseInfo1, {
                [css.spacing]: type === 1
              })}
            >
              <div className={css.courseTitle}>{item.name}</div>
              <div className={css.courseAccess1}>
                {this.context.getIntlMessage('invite.accessTime')} :{' '}
                {accessDescription}{' '}
              </div>
            </div>

            <div
              className={css.panel}
              dangerouslySetInnerHTML={{ __html: presentation }}
            />

            <div className={css.ownerInfo1}>
              <div className={css.profileImage1}>
                <ProfileImage author={{ avatar: owner.avatarUrl }} />
              </div>
              <div>{this.context.getIntlMessage('store.yourCourseLeader')}</div>
              <div className={css.courseTitle}>{item.ownerName}</div>
            </div>
            <LinkList
              links={links}
              style={{ marginTop: '3em' }}
              username={store}
              onClickLink={() => this.setState({ tac: true })}
            />
          </div>
        )}
        {tab === 'edit' && (
          <div className={css.panel}>
            <StoreItemEditPanel
              type={type}
              id={id}
              presentation={presentation}
              price={price}
              isPublic={!!item.public}
              ucpPeriod={ucpPeriod}
              videoUrl={item.videoUrl}
              themeColor={ThemeStore.getColor(themeColor)}
            />
          </div>
        )}
      </div>
    );
  }

  buyCourse = () => {
    StoreOverviewActions.addToCart(this.props.item);
  };

  giftCourse = () => {
    StoreOverviewActions.addToCart(this.props.item, true);
  };

  renderBottomBar() {
    const { getIntlMessage } = this.context;
    const { themeColor, owner, item } = this.props;
    const { price, currency, type } = item;
    const builderColor = ThemeStore.getColor(themeColor);
    const ucpPeriod = parseInt(item.ucpPeriod, 10);

    const accessMonths = Math.floor(ucpPeriod / (24 * 60 * 60 * 30));
    const accessDescription = lookup[accessMonths] ? (
      getIntlMessage('invite.' + lookup[accessMonths])
    ) : (
      <FormattedMessage
        message={getIntlMessage('invite.accessMonths')}
        months={accessMonths}
      />
    );

    return (
      <div className={css.footer}>
        {type === 2 && (
          <div className={css.packageInfo}>
            <div className={css.packBadge}>
              <SvgIcons.ActionViewModule color={Colors.fullWhite} />
              <FormattedMessage
                message={this.context.getIntlMessage('store.packOf')}
                count={item.courses.length}
              />
            </div>
          </div>
        )}
        <div
          className={classNames(css.courseInfo, { [css.spacing]: type === 1 })}
        >
          <div className={css.courseTitle}>{item.name}</div>
          <div className={css.courseAccess}>
            {this.context.getIntlMessage('invite.accessTime')} :{' '}
            {accessDescription}{' '}
          </div>
        </div>
        <div className={css.ownerInfo}>
          <div className={css.profileImage}>
            <ProfileImage author={{ avatar: owner.avatarUrl }} />
          </div>
          <div>{this.context.getIntlMessage('store.yourCourseLeader')}</div>
          <div className={css.courseTitle}>{item.ownerName}</div>
        </div>
        <div className={css.callToAction}>
          <div className={css.buttonWrapper}>
            <div onTouchTap={this.buyCourse} className={css.buyButton}>
              <FormattedMessage
                message={this.context.getIntlMessage('store.buyFor')}
                price={
                  <FormattedNumber
                    style="currency"
                    currency={currency}
                    maximumFractionDigits={0}
                    minimumFractionDigits={0}
                    value={Math.round(price.discounted)}
                  />
                }
              />
            </div>
          </div>
          <div className={css.giftButtonWrapper}>
            <div onTouchTap={this.giftCourse} className={css.giftButton}>
              <Gift className={css.giftIcon} />{' '}
              {this.context.getIntlMessage('store.giftCourse')}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderContent(item) {
    const { getIntlMessage } = this.context;
    const { canIEdit } = this.props;
    const videoUrl = this.parseVideoUrl(item.videoUrl);
    return (
      <div className={css.content}>
        {(videoUrl || (!videoUrl && canIEdit)) && (
          <div className={css.videoContainer}>
            {videoUrl && <EmbeddedVideoPreview source={videoUrl} />}
            {!videoUrl &&
              canIEdit && (
                <div
                  style={{
                    margin: 32,
                    borderRadius: 2,
                    border: 'solid 1px #BBB',
                    backgroundColor: '#DDD',
                    padding: '128px 64px',
                    textAlign: 'center',
                    fontSize: 24,
                    lineHeight: '32px'
                  }}
                >
                  {getIntlMessage('store.chooseVideo')}
                </div>
              )}
          </div>
        )}
      </div>
    );
  }

  renderTopBar(item) {
    const { store, logoUrl } = this.props;
    return (
      <div className={css.topBar}>
        <StoreBar store={store} logo={logoUrl} title={item.name} />
      </div>
    );
  }

  render() {
    const { item, store, canIEdit } = this.props;
    const { tac } = this.state;
    const { videoUrl } = item;
    const noVideo = !(videoUrl || (!videoUrl && canIEdit));

    return (
      <div className={classNames(css.root, { [css.noVideo]: noVideo })}>
        <div className={css.body}>
          <div className={css.main}>{this.renderContent(item)}</div>
          {this.renderSideBar(item)}
        </div>
        {this.renderTopBar(item)}
        <GiftDialog />
        <TaC
          username={store}
          open={tac}
          onRequestClose={() => this.setState({ tac: false })}
        />
        {this.renderBottomBar(item)}
        <Helmet
          title={item.name}
          meta={[
            { name: 'twitter:card', content: 'summary_large_image' },
            {
              name: 'twitter:image',
              content:
                item.coverImage[0].url ||
                'https://res.cloudinary.com/teamtailor/image/upload/c_limit,dpr_2.0,f_auto,h_65,q_80,w_200/v1476197337/divchtdesiriwvpnri3e.png'
            },
            { name: 'og:title', content: item.name },
            {
              name: 'og:image',
              content:
                item.coverImage[0].url ||
                'https://res.cloudinary.com/teamtailor/image/upload/c_limit,dpr_2.0,f_auto,h_65,q_80,w_200/v1476197337/divchtdesiriwvpnri3e.png'
            },
            {
              name: 'og:description',
              content: cleanWordHTML(item.presentation)
            }
          ]}
        />
      </div>
    );
  }
}

const cleanWordHTML = (str) => {
  let tmp = document.createElement('DIV');
  tmp.innerHTML = str;
  let newString = tmp.textContent || tmp.innerText;
  newString = newString.replace(/\n\n/g, '<br />').replace(/.*<!--.*-->/g, '');
  // this next piece removes any break tags (up to 10) at beginning
  for (let i = 0; i < 10; i++) {
    if (newString.substr(0, 6) === '<br />') {
      newString = newString.replace('<br />', ' ');
    }
  }
  return newString.replace(/<(?:.|\n)*?>/gm, '');
};

export default StoreItem;



// WEBPACK FOOTER //
// ./src/js/components/Store/StoreItem.js